import { Component } from "@angular/core";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateHtmlEditorComponent } from "../../templates/template-html-editor/template-html-editor.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-b14",
  imports: [TemplateHtmlEditorComponent],
  templateUrl: "./prefix-b14.component.html",
  styleUrl: "./prefix-b14.component.less",
})
export class PrefixB14Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 100000;
  }
}
